
import data from './full_china.data.json'

const list = []
//省/直辖市列表
const provinces = []
//市列表
const cities = []
// 区/县列表
const areas = []

Object.entries(data).forEach(val => {
  const [key, value] = val
  const code = Number.parseInt(key)
  const model = { key, value }
  list.push(model)
  if (!(code % 1e4)) {
    // xx0000 为省级编码格式
    provinces.push(model)
  } else if (!(code % 100)) {
    // xxxx00 为市级编码格式
    cities.push(model)
  } else {
    // 后四位数处理
    if (Number(key.substring(2)) > 9000) {
      cities.push(model)
    } else {
      areas.push(model)
    }
  }
})

export function getProvinces() {
  return provinces;
}

export function getCities(provinceKey) {
  if (!provinceKey) return []

  const num = Number.parseInt(provinceKey)

  const list = cities.filter(val => {
    return (val.key - num) < 1e4 && (val.key % num) < 1e4
  })
  // Municipalities directly under the central government
  if (list.length == 0) {
    return [{ key: provinceKey, value: data[provinceKey] }]
  }

  return list
}


//  export function getAreas (city) {
//   if (!city || !Object.keys(city).length) return []

//   const cityKey = Number.parseInt(city.key)
//   const isNotProvince = cityKey % 1e4
//   const calcNum = isNotProvince ? 100 : 1e4
//   const list = areas.filter(val => {
//     return (val.key - cityKey) < calcNum && val.key % cityKey < calcNum
//   })
//   // Prefecture-level city
//   return list.length ? list : [city]
// }


export function getLocatedProvinces(lang) {
  let provinces = getProvinces();
  if (lang == 'zh') {
    return provinces.map(x => ({ key: x.key, value: x.value?.zh }))
  } else {
    return provinces.map(x => ({ key: x.key, value: x.value?.pt }))
  }
}

export function getLocatedGetCities(lang, provinceKey) {
  let cities = getCities(provinceKey);
  if (lang == 'zh') {
    return cities.map(x => ({ key: x.key, value: x.value?.zh }))
  } else {
    return cities.map(x => ({ key: x.key, value: x.value?.pt }))
  }
}